// /**时间格式化 */
import moment from "moment";

const DATETIME_PICKER_FORMAT = "YYYY-MM-DD HH:mm";
const DATE_PICKER_FORMAT = "YYYY-MM-DD";

// 日志时间戳格式化
const LOG_DATE_FORMAT = "YYYY-MM-DD HH:mm:ss";

export const dateFormat = (str?: string | number | Date, format: string = DATE_PICKER_FORMAT) => {
    if (!str) {
        return "";
    }
    return moment(str).format(format);
};
export const dateTimeFormat = (str?: string | number | Date, format: string = DATETIME_PICKER_FORMAT) => {
    if (!str) {
        return "";
    }
    return moment(str).format(format);
};
export const dateTimesFormat = (str?: string | Date, format: string = LOG_DATE_FORMAT) => {
    if (!str) {
        return;
    }
    return moment(str).format(format);
};

export const durationFormat = (time: string) => {
    if (!time) return "";
    return timeDifferenceFormat(new Date(), new Date(time));
};

export const timeDifferenceFormat = (startTime: Date, endTime: Date) => {
    // 定义开始时间和结束时间
    const start = new Date(startTime).getTime();
    const end = new Date(endTime).getTime();
    // 计算时间差（单位：毫秒）
    const timeDiff = Math.abs(end - start);
    // 将时间差转换为天、小时和分钟
    const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
    // 格式化时间差
    return `${days}天${hours}小时${minutes}分钟`;
};
